import { animate } from 'motion';

const elements = document.querySelectorAll('.animated-txt');

elements.forEach(el => {
  const wrapTextNodes = node => {
    Array.from(node.childNodes).forEach(child => {
      if (child.nodeType === 3) {
        const text = child.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;

        const words = text.split(' ');
        const fragment = document.createDocumentFragment();

        words.forEach((word, i) => {
          const div = document.createElement('div');
          div.className = 'word';
          div.textContent = word;
          fragment.appendChild(div);

          if (i < words.length - 1) {
            fragment.appendChild(document.createTextNode(' '));
          }
        });

        child.replaceWith(fragment);
      }
    });
  };

  wrapTextNodes(el);

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        const words = el.querySelectorAll('.word');
        if (entry.isIntersecting) {
          animate(
            words,
            {
              opacity: [0, 1],
              transform: ['translateY(25%)', 'translateY(0)'],
            },
            {
              // duration: 0.7,
              duration: 0.4,
              delay: i => 0.3 + i * 0.2,
              easing: 'ease-out',
            }
          );
        } else {
          animate(
            words,
            {
              opacity: [1, 0],
              transform: ['translateY(0)', 'translateY(25%)'],
            },
            {
              duration: 0.3,
              delay: i => i * 0,
              easing: 'ease',
            }
          );
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(el);
});
